let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eYO2a")).then(() => parcelRequire('4NXAh'));